export default (that) => [
  {
    text: that.$l('btn_tips_view') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    show: ({ userReimbursementStatus }) => userReimbursementStatus === 'N' || userReimbursementStatus === 'R',
  },
  {
    text: that.$l('btn_tips_del') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    show: ({ userReimbursementStatus }) => userReimbursementStatus === 'N' || userReimbursementStatus === 'R',
  },
  {
    text: that.$l('btn_tips_submit_oa_os_approval') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'approval',
    divided: true,
    allow: 'T',
    data: {},
    show: ({ userReimbursementStatus }) => userReimbursementStatus === 'N' || userReimbursementStatus === 'R',
  },
  {
    text: that.$l('btn_tips_rejected') || '强制驳回',
    icon: 'el-icon-refresh-left',
    menuType: 'rejected',
    divided: true,
    allow: 'R',
    data: {},
    show: ({ userPaymentRequestStatus }) => userPaymentRequestStatus === 'Y',
  }
]
